export const AGENS_REDUCER_STATE_ID = 'agens';
